(function () {
  'use strict';

  /* ------------------------------------------------------------------ helpers */

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatClock(date) {
    return pad(date.getHours()) + ':' + pad(date.getMinutes());
  }

  function escapeId(id) {
    return window.CSS && CSS.escape ? CSS.escape(id) : id;
  }

  function renderCountdownBoxes(container, totalSeconds) {
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var units = [pad(hours), pad(minutes), pad(seconds)];

    container.textContent = '';
    units.forEach(function (unit, index) {
      var box = document.createElement('span');
      box.className = 'tab__countdown-unit';
      box.textContent = unit;
      container.appendChild(box);

      if (index < units.length - 1) {
        var sep = document.createElement('span');
        sep.className = 'tab__countdown-sep';
        sep.textContent = ':';
        container.appendChild(sep);
      }
    });
  }

  /* ----------------------------------------------------------------- carousel */

  function initCarousel(node) {
    if (!node || node.dataset.carouselInit === 'true') return;
    node.dataset.carouselInit = 'true';

    var track = node.querySelector('[data-carousel-track]');
    var prevBtn = node.querySelector('[data-carousel-prev]');
    var nextBtn = node.querySelector('[data-carousel-next]');
    if (!track) return;

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      if (track.clientWidth === 0) return; // panel is hidden, nothing to measure
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollByAmount(direction) {
      track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initCarouselsIn(scope) {
    (scope || document).querySelectorAll('[data-hot-promotion-carousel]').forEach(initCarousel);
  }

  /* -------------------------------------------------------- tabs + countdown */

  function initCountdowns(root) {
    if (root.dataset.hpCountdownInit === 'true') return; // guard: no stacked intervals
    root.dataset.hpCountdownInit = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-hot-promotion-tab]'));
    if (!tabs.length) return;

    var timerId = null;
    var panelObserver = null;

    function panelFor(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? root.querySelector('#' + escapeId(id)) : null;
    }

    function isActive(tab) {
      return tab.disabled || tab.getAttribute('aria-selected') === 'true';
    }

    function activate(tab) {
      if (tab && !isActive(tab) && typeof tab.click === 'function') tab.click();
    }

    function stop() {
      if (timerId) { clearInterval(timerId); timerId = null; }
      if (panelObserver) { panelObserver.disconnect(); panelObserver = null; }
    }

    // Guarantee exactly one panel is visible and it matches the active tab.
    function syncPanels() {
      var active = tabs.filter(isActive)[0] || tabs[0];
      tabs.forEach(function (t) {
        var p = panelFor(t);
        if (!p) return;
        if (t === active) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      if (active) {
        activate(active);
        initCarouselsIn(panelFor(active));
      }
      window.dispatchEvent(new Event('resize'));
    }

    function retireTab(tab) {
      var idx = tabs.indexOf(tab);
      if (idx === -1) return;

      var wasActive = isActive(tab);
      var panel = panelFor(tab);

      // 1. drop it from the live list so tick() stops touching it
      tabs.splice(idx, 1);

      // 2. pull it out of the visual + interaction flow immediately
      tab.setAttribute('hidden', '');
      tab.setAttribute('aria-hidden', 'true');
      tab.disabled = false; // stop the tab widget from treating it as "current"
      if (panel) panel.setAttribute('hidden', '');

      // 3. nothing left -> hide the whole section
      if (!tabs.length) {
        if (panel) panel.remove();
        tab.remove();
        root.setAttribute('hidden', '');
        stop();
        return;
      }

      // 4. if it was the open tab, open the next surviving one (or the previous)
      var nextTab = tabs[idx] || tabs[idx - 1];
      if (wasActive) activate(nextTab);

      // 5. remove the DOM nodes only after the tab widget has finished switching
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (panel) panel.remove();
          tab.remove();
          syncPanels();
        });
      });
    }

    function tick() {
      var now = Date.now();
      tabs.slice().forEach(function (tab) {
        var end = tab.dataset.countdownEnd;
        if (!end) return;

        var endTime = new Date(end).getTime();
        if (isNaN(endTime)) {
          if (window.Shopify && Shopify.designMode) {
            console.warn('[hot-promotion] Countdown end khong hop le:', end, tab);
          }
          return;
        }

        var label = tab.querySelector('[data-tab-label]');
        var display = tab.querySelector('[data-countdown-display]');
        var labelCounting = tab.dataset.labelCounting;
        var labelPending = tab.dataset.labelPending;

        var start = tab.dataset.countdownStart;
        var startTime = start ? new Date(start).getTime() : NaN;

        // --- "Sap dien ra": chua toi gio bat dau -> hien thi gio bat dau ---
        if (!isNaN(startTime) && now < startTime) {
          tab.classList.remove('is-counting');
          tab.classList.add('is-pending');
          if (label && labelPending) label.textContent = labelPending;
          if (display) display.textContent = formatClock(new Date(startTime));
          return;
        }

        var diff = endTime - now;
        if (diff <= 0) {
          retireTab(tab);
          return;
        }

        // --- Dang dem nguoc ---
        tab.classList.remove('is-pending');
        tab.classList.add('is-counting');
        if (label && labelCounting) label.textContent = labelCounting;
        if (display) renderCountdownBoxes(display, Math.floor(diff / 1000));
      });
    }

    // When the tab widget toggles [hidden] on a panel, resize + lazy-init its carousel.
    if (typeof MutationObserver !== 'undefined') {
      panelObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          var panel = m.target;
          if (!panel.hasAttribute('hidden')) {
            initCarouselsIn(panel);
            window.dispatchEvent(new Event('resize'));
          }
        });
      });
      root.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
        panelObserver.observe(p, { attributes: true, attributeFilter: ['hidden'] });
      });
    }

    tick();
    timerId = setInterval(tick, 1000);

    root.addEventListener('hot-promotion:destroy', stop, { once: true });
  }

  /* -------------------------------------------------------------------- boot */

  function initSection(root) {
    if (!root) return;
    initCountdowns(root);
    initCarouselsIn(root);
  }

  document.querySelectorAll('[data-hot-promotion-section]').forEach(initSection);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-hot-promotion-section]');
      if (root) initSection(root);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-hot-promotion-section]');
      if (root) root.dispatchEvent(new Event('hot-promotion:destroy'));
    });
  }
})();
